"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = InvoicePdfPreview;
const react_1 = __importStar(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
const react_router_dom_1 = require("react-router-dom");
const MainSetupReact_1 = __importDefault(require("../../../React/MainSetupReact"));
const qrcode_react_1 = require("qrcode.react");
// Mapowanie pól podsumowania VAT ze schematu FA(3): pole netto (P_13_x),
// odpowiadające mu pole VAT (P_14_x, jeśli istnieje) oraz etykieta stawki/typu.
const VAT_SUMMARY_FIELDS = [
    { netField: "P_13_1", vatField: "P_14_1", label: "23% lub 22%" },
    { netField: "P_13_2", vatField: "P_14_2", label: "8% lub 7%" },
    { netField: "P_13_3", vatField: "P_14_3", label: "5%" },
    { netField: "P_13_4", vatField: "P_14_4", label: "4% (taxi)" },
    { netField: "P_13_5", vatField: "P_14_5", label: "Procedura szczególna" },
    { netField: "P_13_6_1", label: "0% (kraj)" },
    { netField: "P_13_6_2", label: "0% (WDT)" },
    { netField: "P_13_6_3", label: "0% (eksport)" },
    { netField: "P_13_7", label: "zw." },
    { netField: "P_13_8", label: "np. (poza terytorium kraju)" },
    { netField: "P_13_9", label: "np. (art. 100 ust. 1 pkt 4)" },
    { netField: "P_13_10", label: "odwrotne obciążenie" },
    { netField: "P_13_11", label: "marża" },
];
function parseAmount(value) {
    if (!value)
        return 0;
    const parsed = Number(value.replace(/\s/g, "").replace(",", "."));
    return Number.isFinite(parsed) ? parsed : 0;
}
function formatAmount(value) {
    return value.toLocaleString("pl-PL", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });
}
// Stawka pozycji (P_12): wartość liczbowa z "%", tokeny zw/np/oo bez zmian.
function formatVatRate(rate) {
    const trimmed = (rate || "").trim();
    if (!trimmed)
        return "";
    return /^-?\d+([.,]\d+)?$/.test(trimmed) ? `${trimmed}%` : trimmed;
}
function getCorrectionTypeLabel(correctionType) {
    if (correctionType === "1") {
        return "Korekta skutkująca w dacie ujęcia faktury pierwotnej";
    }
    if (correctionType === "2") {
        return "Korekta skutkująca w dacie wystawienia faktury korygującej";
    }
    if (correctionType === "3") {
        return "Korekta skutkująca w dacie innej, w tym gdy dla różnych pozycji faktury korygującej daty te są różne";
    }
    return "(nie ustawiono)";
}
function findFirstByLocalName(root, localName) {
    const all = root.getElementsByTagName("*");
    for (let i = 0; i < all.length; i++) {
        if (all[i].localName === localName) {
            return all[i];
        }
    }
    return null;
}
function findChildrenByLocalName(parent, localName) {
    const result = [];
    for (let i = 0; i < parent.children.length; i++) {
        const child = parent.children[i];
        if (child.localName === localName) {
            result.push(child);
        }
    }
    return result;
}
function findAllByLocalName(root, localName) {
    const result = [];
    const all = root.getElementsByTagName("*");
    for (let i = 0; i < all.length; i++) {
        if (all[i].localName === localName) {
            result.push(all[i]);
        }
    }
    return result;
}
function mapKsefFlagToTakNie(value) {
    if (value === "1")
        return "TAK";
    if (value === "2")
        return "NIE";
    return "-";
}
const THIRD_PARTY_ROLE_LABELS = {
    "1": "Faktor - w przypadku gdy na fakturze występują dane faktora",
    "2": "Odbiorca - w przypadku gdy na fakturze występują dane jednostek wewnętrznych, oddziałów, wyodrębnionych w ramach nabywcy, które same nie stanowią nabywcy w rozumieniu ustawy",
    "3": "Podmiot pierwotny - w przypadku gdy na fakturze występują dane podmiotu będącego w stosunku do podatnika podmiotem przejętym lub przekształconym, który dokonywał dostawy lub świadczył usługę",
    "4": "Dodatkowy nabywca - w przypadku gdy na fakturze występują dane kolejnych (innych niż wymieniony w części Podmiot2) nabywców",
    "5": "Wystawca faktury - w przypadku gdy na fakturze występują dane podmiotu wystawiającego fakturę w imieniu podatnika",
    "6": "Dokonujący płatności - w przypadku gdy na fakturze występują dane podmiotu regulującego zobowiązanie w miejsce nabywcy",
    "7": "Jednostka samorządu terytorialnego - wystawca",
    "8": "Jednostka samorządu terytorialnego - odbiorca",
    "9": "Członek grupy VAT - wystawca",
    "10": "Członek grupy VAT - odbiorca",
    "11": "Pracownik",
};
function getThirdPartyRoleLabel(role) {
    if (!role)
        return "";
    return THIRD_PARTY_ROLE_LABELS[role] || `Rola ${role}`;
}
function getChildText(parent, localName) {
    if (!parent)
        return "";
    const child = findChildrenByLocalName(parent, localName)[0];
    return (child?.textContent || "").trim();
}
function parsePreviewXml(xml) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(xml, "application/xml");
    const parserError = doc.getElementsByTagName("parsererror")[0];
    if (parserError) {
        throw new Error("Nie udało się sparsować XML podglądu faktury");
    }
    const podmiot1 = findFirstByLocalName(doc, "Podmiot1");
    const podmiot2 = findFirstByLocalName(doc, "Podmiot2");
    const podmiot3List = findAllByLocalName(doc, "Podmiot3");
    const fa = findFirstByLocalName(doc, "Fa");
    const platnosc = findFirstByLocalName(doc, "Platnosc");
    const podmiot1Id = podmiot1 ? findFirstByLocalName(podmiot1, "DaneIdentyfikacyjne") : null;
    const podmiot1Adr = podmiot1 ? findFirstByLocalName(podmiot1, "Adres") : null;
    const podmiot2Id = podmiot2 ? findFirstByLocalName(podmiot2, "DaneIdentyfikacyjne") : null;
    const podmiot2Adr = podmiot2 ? findFirstByLocalName(podmiot2, "Adres") : null;
    const rachunekBankowy = platnosc ? findFirstByLocalName(platnosc, "RachunekBankowy") : null;
    const terminPlatnosci = platnosc ? findFirstByLocalName(platnosc, "TerminPlatnosci") : null;
    const daneFaKorygowanej = fa ? findFirstByLocalName(fa, "DaneFaKorygowanej") : null;
    const items = [];
    if (fa) {
        const faLines = fa.getElementsByTagName("*");
        for (let i = 0; i < faLines.length; i++) {
            if (faLines[i].localName !== "FaWiersz")
                continue;
            const row = faLines[i];
            items.push({
                lineNo: getChildText(row, "NrWierszaFa"),
                name: getChildText(row, "P_7"),
                unit: getChildText(row, "P_8A"),
                quantity: getChildText(row, "P_8B"),
                unitPrice: getChildText(row, "P_9A"),
                netValue: getChildText(row, "P_11"),
                vatRate: getChildText(row, "P_12"),
            });
        }
    }
    const vatSummary = [];
    const vatSummaryTotals = { net: 0, vat: 0, gross: 0 };
    if (fa) {
        for (const field of VAT_SUMMARY_FIELDS) {
            const netEl = findChildrenByLocalName(fa, field.netField)[0];
            const vatEl = field.vatField ? findChildrenByLocalName(fa, field.vatField)[0] : undefined;
            if (!netEl && !vatEl)
                continue;
            const net = parseAmount((netEl?.textContent || "").trim());
            const vat = parseAmount((vatEl?.textContent || "").trim());
            const gross = Math.round((net + vat) * 100) / 100;
            vatSummary.push({ rateLabel: field.label, net, vat, gross });
            vatSummaryTotals.net += net;
            vatSummaryTotals.vat += vat;
            vatSummaryTotals.gross += gross;
        }
        vatSummaryTotals.net = Math.round(vatSummaryTotals.net * 100) / 100;
        vatSummaryTotals.vat = Math.round(vatSummaryTotals.vat * 100) / 100;
        vatSummaryTotals.gross = Math.round(vatSummaryTotals.gross * 100) / 100;
    }
    const thirdParties = podmiot3List.map((podmiot3) => {
        const podmiot3Id = findFirstByLocalName(podmiot3, "DaneIdentyfikacyjne");
        const podmiot3Adr = findFirstByLocalName(podmiot3, "Adres");
        return {
            name: getChildText(podmiot3Id, "Nazwa"),
            nip: getChildText(podmiot3Id, "NIP"),
            internalId: getChildText(podmiot3Id, "IDWew"),
            line1: getChildText(podmiot3Adr, "AdresL1"),
            line2: getChildText(podmiot3Adr, "AdresL2"),
            role: getChildText(podmiot3, "Rola"),
        };
    });
    return {
        invoiceNumber: getChildText(fa, "P_2"),
        issueDate: getChildText(fa, "P_1"),
        saleDate: getChildText(fa, "P_6"),
        totalGross: getChildText(fa, "P_15"),
        invoiceType: getChildText(fa, "RodzajFaktury"),
        correctionType: getChildText(fa, "TypKorekty"),
        correctionReason: getChildText(fa, "PrzyczynaKorekty"),
        correctedIssueDate: getChildText(daneFaKorygowanej, "DataWystFaKorygowanej"),
        correctedNumber: getChildText(daneFaKorygowanej, "NrFaKorygowanej"),
        correctedKsefNumber: getChildText(daneFaKorygowanej, "NrKSeFFaKorygowanej"),
        paymentDeadline: getChildText(terminPlatnosci, "Termin"),
        bankAccount: getChildText(rachunekBankowy, "NrRB"),
        bankName: getChildText(rachunekBankowy, "NazwaBanku"),
        seller: {
            name: getChildText(podmiot1Id, "Nazwa"),
            nip: getChildText(podmiot1Id, "NIP"),
            line1: getChildText(podmiot1Adr, "AdresL1"),
            line2: getChildText(podmiot1Adr, "AdresL2"),
            jst: "",
            gv: "",
        },
        buyer: {
            name: getChildText(podmiot2Id, "Nazwa"),
            nip: getChildText(podmiot2Id, "NIP"),
            line1: getChildText(podmiot2Adr, "AdresL1"),
            line2: getChildText(podmiot2Adr, "AdresL2"),
            jst: mapKsefFlagToTakNie(getChildText(podmiot2, "JST")),
            gv: mapKsefFlagToTakNie(getChildText(podmiot2, "GV")),
        },
        thirdParties,
        items,
        vatSummary,
        vatSummaryTotals,
    };
}
function InvoicePdfPreview() {
    const { id } = (0, react_router_dom_1.useParams)();
    const navigate = (0, react_router_dom_1.useNavigate)();
    const [xml, setXml] = (0, react_1.useState)("");
    const [loading, setLoading] = (0, react_1.useState)(true);
    const [error, setError] = (0, react_1.useState)("");
    const [ksefPreviewStatus, setKsefPreviewStatus] = (0, react_1.useState)(null);
    (0, react_1.useEffect)(() => {
        let cancelled = false;
        async function loadPreview() {
            if (!id) {
                setError("Brak id faktury w adresie.");
                setLoading(false);
                return;
            }
            setLoading(true);
            setError("");
            setKsefPreviewStatus(null);
            try {
                const response = await fetch(`${MainSetupReact_1.default.serverUrl}invoice/${id}/ksef/xml-preview`, {
                    method: "GET",
                    credentials: "include",
                });
                if (!response.ok) {
                    const payload = await response.json().catch(() => ({}));
                    throw new Error(payload.error || payload.errorMessage || `Błąd serwera (${response.status})`);
                }
                const text = await response.text();
                if (!cancelled) {
                    setXml(text);
                }
                if (!cancelled) {
                    try {
                        const statusResponse = await fetch(`${MainSetupReact_1.default.serverUrl}invoice/${id}/ksef/status`, {
                            method: "GET",
                            credentials: "include",
                        });
                        if (statusResponse.ok) {
                            const statusData = await statusResponse.json();
                            if (!cancelled && statusData?.qrVerificationUrl) {
                                setKsefPreviewStatus({
                                    qrVerificationUrl: statusData.qrVerificationUrl,
                                    qrLabel: statusData.qrLabel,
                                    ksefNumber: statusData.ksefNumber,
                                });
                            }
                        }
                    }
                    catch {
                        // Preview PDF nadal działa bez QR, jeśli status KSeF chwilowo nie jest dostępny.
                    }
                }
            }
            catch (err) {
                if (!cancelled) {
                    setError(err instanceof Error ? err.message : "Nie udało się pobrać podglądu faktury");
                }
            }
            finally {
                if (!cancelled) {
                    setLoading(false);
                }
            }
        }
        loadPreview();
        return () => {
            cancelled = true;
        };
    }, [id]);
    const parsedResult = (0, react_1.useMemo)(() => {
        if (!xml)
            return { data: null, parseError: "" };
        try {
            return { data: parsePreviewXml(xml), parseError: "" };
        }
        catch (err) {
            return {
                data: null,
                parseError: err instanceof Error ? err.message : "Błąd parsowania XML",
            };
        }
    }, [xml]);
    const parsed = parsedResult.data;
    const daysToPay = parsed?.issueDate && parsed?.paymentDeadline
        ? Math.round((new Date(parsed.paymentDeadline).getTime() - new Date(parsed.issueDate).getTime()) / 86400000)
        : null;
    const isCorrectionInvoice = parsed?.invoiceType?.startsWith("KOR") || false;
    const hasKsefQr = Boolean(ksefPreviewStatus?.qrVerificationUrl);
    const ksefInvoiceNumber = ksefPreviewStatus?.ksefNumber || ksefPreviewStatus?.qrLabel || "";
    if (loading) {
        return (react_1.default.createElement(react_bootstrap_1.Container, { className: "py-4" },
            react_1.default.createElement(react_bootstrap_1.Spinner, { animation: "border", size: "sm", className: "me-2" }),
            "Generowanie podgl\u0105du PDF..."));
    }
    if (error || parsedResult.parseError) {
        return (react_1.default.createElement(react_bootstrap_1.Container, { className: "py-4" },
            react_1.default.createElement(react_bootstrap_1.Alert, { variant: "danger" }, error || parsedResult.parseError),
            react_1.default.createElement(react_router_dom_1.Link, { to: `/invoice/${id}` }, "Wr\u00F3\u0107 do faktury")));
    }
    if (!parsed) {
        return (react_1.default.createElement(react_bootstrap_1.Container, { className: "py-4" },
            react_1.default.createElement(react_bootstrap_1.Alert, { variant: "warning" }, "Brak danych podgl\u0105du.")));
    }
    return (react_1.default.createElement(react_bootstrap_1.Container, { className: "py-3 invoice-preview-page" },
        react_1.default.createElement("style", null, `
                @media print {
                    @page {
                        size: A4;
                        margin: 0 !important;
                    }
                    body > #root .navbar.sticky-top,
                    body > #root .navbar.mt-auto,
                    body > .good-tip-toast-wrapper,
                    body > .toast-container {
                        display: none !important;
                    }
                    .no-print { display: none !important; }
                    .invoice-preview-page > :not(.invoice-sheet):not(.invoice-qr-print-section) {
                        display: none !important;
                    }
                    body { background: #fff !important; margin: 0 !important; padding: 0 !important; }
                    .invoice-preview-page {
                        width: 100% !important;
                        max-width: none !important;
                        padding: 0 !important;
                        margin: 0 auto !important;
                        box-sizing: border-box !important;
                    }
                    .invoice-sheet {
                        width: 100% !important;
                        max-width: 190mm !important;
                        padding: 10mm !important;
                        margin: 0 auto !important;
                        box-sizing: border-box !important;
                        box-shadow: none !important;
                        border: none !important;
                    }
                    .invoice-qr-print-section {
                        break-before: page;
                        page-break-before: always;
                        break-inside: avoid;
                        page-break-inside: avoid;
                    }
                    .invoice-qr-preview-section {
                        display: none !important;
                    }
                    .invoice-qr-preview-actions {
                        display: none !important;
                    }
                }
                .invoice-sheet {
                    width: 100%;
                    max-width: 190mm;
                    margin: 0 auto;
                    padding: 24px 28px;
                    background: #fff;
                    color: #212529;
                    border: 1px solid #e3e3e3;
                    box-shadow: 0 6px 18px rgba(0,0,0,0.08);
                }
                .invoice-ksef-title {
                    letter-spacing: 0.04em;
                    font-weight: 700;
                    font-size: 1.3rem;
                }
                .preview-badge {
                    display: inline-block;
                    padding: 0.2rem 0.6rem;
                    border: 1px solid #adb5bd;
                    border-radius: 999px;
                    font-size: 0.72rem;
                    letter-spacing: 0.03em;
                }
                .invoice-mono { font-family: Consolas, "Courier New", monospace; }
                .inv-head {
                    display: flex;
                    justify-content: flex-end;
                    align-items: flex-start;
                }
                .inv-meta { white-space: nowrap; }
                .inv-title { text-align: center; white-space: nowrap; margin-top: 6px; }
                .inv-ksef-sub { text-align: center; font-size: 0.7rem; color: #868e96; white-space: nowrap; margin-top: 2px; }
                .inv-correction { font-size: 0.55rem; }
                .inv-account { white-space: nowrap; }
                .inv-pay { display: flex; gap: 32px; flex-wrap: wrap; }
                .inv-pay > div { flex: 0 1 auto; min-width: 0; }
                .inv-section { margin-top: 22px; }
                .inv-label {
                    font-size: 0.7rem;
                    text-transform: uppercase;
                    letter-spacing: 0.06em;
                    color: #868e96;
                    font-weight: 600;
                    margin-bottom: 4px;
                }
                .inv-cols { display: flex; gap: 32px; }
                .inv-cols > div { flex: 1; min-width: 0; }
                .inv-table { width: 100%; border-collapse: collapse; font-size: 0.85rem; }
                .inv-table th, .inv-table td { padding: 6px 8px; }
                .inv-table thead th {
                    text-align: left;
                    font-size: 0.7rem;
                    text-transform: uppercase;
                    letter-spacing: 0.03em;
                    color: #868e96;
                    border-bottom: 1.5px solid #343a40;
                }
                .inv-table tbody td { border-bottom: 1px solid #edeef0; }
                .inv-table tfoot th { border-top: 1.5px solid #343a40; font-weight: 600; }
                .inv-num { text-align: right; white-space: nowrap; }
                .inv-total { text-align: right; }
                .inv-total .amt { font-size: 1.3rem; font-weight: 700; margin-left: 10px; }
            `),
        react_1.default.createElement("div", { className: "d-flex justify-content-between align-items-center mb-3 no-print" },
            react_1.default.createElement("div", null,
                react_1.default.createElement("h5", { className: "mb-1" }, "Podgl\u0105d faktury do PDF"),
                react_1.default.createElement("div", { className: "text-muted small" }, "Widok generowany z aktualnego XML")),
            react_1.default.createElement("div", { className: "d-flex gap-2" },
                react_1.default.createElement(react_bootstrap_1.Button, { variant: "outline-secondary", onClick: () => navigate(`/invoice/${id}`) }, "Wr\u00F3\u0107"),
                react_1.default.createElement(react_bootstrap_1.Button, { variant: "primary", onClick: () => window.print() }, "Drukuj / Zapisz PDF"))),
        react_1.default.createElement("div", { className: "invoice-sheet" },
            react_1.default.createElement("div", { className: "inv-head" },
                react_1.default.createElement("div", { className: "text-end inv-meta" },
                    react_1.default.createElement("div", { className: "small" },
                        react_1.default.createElement("strong", null, "Data wystawienia:"),
                        " ",
                        parsed.issueDate || "-"),
                    react_1.default.createElement("div", { className: "small" },
                        react_1.default.createElement("strong", null, "Data sprzeda\u017Cy:"),
                        " ",
                        parsed.saleDate || "-"))),
            react_1.default.createElement("div", { className: "invoice-ksef-title inv-title" },
                "FAKTURA ",
                isCorrectionInvoice ? "korygująca" : "VAT",
                " ",
                parsed.invoiceNumber || "-"),
            ksefInvoiceNumber && (react_1.default.createElement("div", { className: "inv-ksef-sub" },
                "Nr KSeF: ",
                ksefInvoiceNumber)),
            react_1.default.createElement("div", { className: "inv-section inv-cols" },
                react_1.default.createElement("div", null,
                    react_1.default.createElement("div", { className: "inv-label" }, "Sprzedawca"),
                    react_1.default.createElement("div", null,
                        react_1.default.createElement("strong", null, parsed.seller.name || "-")),
                    react_1.default.createElement("div", null,
                        "NIP: ",
                        react_1.default.createElement("span", { className: "invoice-mono" }, parsed.seller.nip || "-")),
                    react_1.default.createElement("div", null, parsed.seller.line1 || "-"),
                    parsed.seller.line2 && react_1.default.createElement("div", null, parsed.seller.line2)),
                react_1.default.createElement("div", null,
                    react_1.default.createElement("div", { className: "inv-label" }, "Nabywca"),
                    react_1.default.createElement("div", null,
                        react_1.default.createElement("strong", null, parsed.buyer.name || "-")),
                    react_1.default.createElement("div", null,
                        "NIP: ",
                        react_1.default.createElement("span", { className: "invoice-mono" }, parsed.buyer.nip || "-")),
                    react_1.default.createElement("div", null, parsed.buyer.line1 || "-"),
                    parsed.buyer.line2 && react_1.default.createElement("div", null, parsed.buyer.line2),
                    react_1.default.createElement("div", { className: "small text-muted mt-1" },
                        react_1.default.createElement("div", null,
                            "Jednostka podrz\u0119dna JST: ",
                            parsed.buyer.jst),
                        react_1.default.createElement("div", null,
                            "Cz\u0142onek grupy VAT: ",
                            parsed.buyer.gv)))),
            isCorrectionInvoice && (react_1.default.createElement("div", { className: "inv-section inv-cols inv-correction" },
                react_1.default.createElement("div", null,
                    react_1.default.createElement("div", { className: "inv-label" }, "Dane faktury korygowanej"),
                    react_1.default.createElement("div", null,
                        react_1.default.createElement("strong", null, "Przyczyna korekty dla faktur koryguj\u0105cych:"),
                        " ",
                        parsed.correctionReason || "-"),
                    parsed.correctionType && (react_1.default.createElement("div", null,
                        react_1.default.createElement("strong", null, "Typ skutku korekty:"),
                        " ",
                        getCorrectionTypeLabel(parsed.correctionType)))),
                react_1.default.createElement("div", null,
                    react_1.default.createElement("div", { className: "inv-label" }, "Dane identyfikacyjne faktury korygowanej"),
                    react_1.default.createElement("div", null,
                        react_1.default.createElement("strong", null, "Data wystawienia faktury, kt\u00F3rej dotyczy faktura koryguj\u0105ca:"),
                        " ",
                        parsed.correctedIssueDate || "-"),
                    react_1.default.createElement("div", null,
                        react_1.default.createElement("strong", null, "Numer faktury korygowanej:"),
                        " ",
                        parsed.correctedNumber || "-"),
                    react_1.default.createElement("div", null,
                        react_1.default.createElement("strong", null, "Numer KSeF faktury korygowanej:"),
                        " ",
                        parsed.correctedKsefNumber || "-")))),
            parsed.thirdParties.length > 0 && (react_1.default.createElement("div", { className: "inv-section" },
                react_1.default.createElement("div", { className: "inv-label" }, "Podmioty trzecie"),
                parsed.thirdParties.map((thirdParty, index) => (react_1.default.createElement("div", { key: `third-party-${index}`, className: index > 0 ? "mt-2" : "" },
                    thirdParty.role && (react_1.default.createElement("div", { className: "text-muted small" }, getThirdPartyRoleLabel(thirdParty.role))),
                    react_1.default.createElement("div", null,
                        react_1.default.createElement("strong", null, thirdParty.name || "-")),
                    react_1.default.createElement("div", null, thirdParty.nip
                        ? react_1.default.createElement(react_1.default.Fragment, null,
                            "NIP: ",
                            react_1.default.createElement("span", { className: "invoice-mono" }, thirdParty.nip))
                        : react_1.default.createElement(react_1.default.Fragment, null,
                            "ID wew.: ",
                            react_1.default.createElement("span", { className: "invoice-mono" }, thirdParty.internalId || "-"))),
                    thirdParty.line1 && react_1.default.createElement("div", null, thirdParty.line1),
                    thirdParty.line2 && react_1.default.createElement("div", null, thirdParty.line2)))))),
            react_1.default.createElement("div", { className: "inv-section" },
                react_1.default.createElement("div", { className: "inv-label" }, "Pozycje faktury"),
                react_1.default.createElement("table", { className: "inv-table" },
                    react_1.default.createElement("thead", null,
                        react_1.default.createElement("tr", null,
                            react_1.default.createElement("th", null, "Lp."),
                            react_1.default.createElement("th", null, "Nazwa"),
                            react_1.default.createElement("th", { className: "inv-num" }, "Il."),
                            react_1.default.createElement("th", null, "JM"),
                            react_1.default.createElement("th", { className: "inv-num" }, "Cena netto"),
                            react_1.default.createElement("th", { className: "inv-num" }, "Warto\u015B\u0107 netto"),
                            react_1.default.createElement("th", { className: "inv-num" }, "VAT"))),
                    react_1.default.createElement("tbody", null, parsed.items.map((item, idx) => (react_1.default.createElement("tr", { key: `preview-item-${idx}` },
                        react_1.default.createElement("td", null, item.lineNo || idx + 1),
                        react_1.default.createElement("td", null, item.name),
                        react_1.default.createElement("td", { className: "inv-num invoice-mono" }, item.quantity),
                        react_1.default.createElement("td", null, item.unit),
                        react_1.default.createElement("td", { className: "inv-num invoice-mono" }, item.unitPrice),
                        react_1.default.createElement("td", { className: "inv-num invoice-mono" }, item.netValue),
                        react_1.default.createElement("td", { className: "inv-num invoice-mono" }, formatVatRate(item.vatRate)))))))),
            react_1.default.createElement("div", { className: "inv-section inv-total" },
                "Razem brutto",
                react_1.default.createElement("span", { className: "amt invoice-mono" },
                    parsed.totalGross || "0.00",
                    " PLN")),
            parsed.vatSummary.length > 0 && (react_1.default.createElement("div", { className: "inv-section" },
                react_1.default.createElement("div", { className: "inv-label" }, "Podsumowanie stawek podatku"),
                react_1.default.createElement("table", { className: "inv-table" },
                    react_1.default.createElement("thead", null,
                        react_1.default.createElement("tr", null,
                            react_1.default.createElement("th", null, "Stawka VAT"),
                            react_1.default.createElement("th", { className: "inv-num" }, "Netto"),
                            react_1.default.createElement("th", { className: "inv-num" }, "VAT"),
                            react_1.default.createElement("th", { className: "inv-num" }, "Brutto"))),
                    react_1.default.createElement("tbody", null, parsed.vatSummary.map((row, idx) => (react_1.default.createElement("tr", { key: `vat-summary-${idx}` },
                        react_1.default.createElement("td", null, row.rateLabel),
                        react_1.default.createElement("td", { className: "inv-num invoice-mono" }, formatAmount(row.net)),
                        react_1.default.createElement("td", { className: "inv-num invoice-mono" }, formatAmount(row.vat)),
                        react_1.default.createElement("td", { className: "inv-num invoice-mono" }, formatAmount(row.gross)))))),
                    react_1.default.createElement("tfoot", null,
                        react_1.default.createElement("tr", null,
                            react_1.default.createElement("th", { className: "inv-num" }, "Razem"),
                            react_1.default.createElement("th", { className: "inv-num invoice-mono" }, formatAmount(parsed.vatSummaryTotals.net)),
                            react_1.default.createElement("th", { className: "inv-num invoice-mono" }, formatAmount(parsed.vatSummaryTotals.vat)),
                            react_1.default.createElement("th", { className: "inv-num invoice-mono" }, formatAmount(parsed.vatSummaryTotals.gross))))))),
            react_1.default.createElement("div", { className: "inv-section" },
                react_1.default.createElement("div", { className: "inv-label" }, "P\u0142atno\u015B\u0107"),
                react_1.default.createElement("div", { className: "inv-pay" },
                    react_1.default.createElement("div", null,
                        react_1.default.createElement("div", { className: "inv-label" }, "Termin p\u0142atno\u015Bci"),
                        react_1.default.createElement("div", null,
                            parsed.paymentDeadline || react_1.default.createElement("span", { className: "text-muted" }, "(puste)"),
                            daysToPay !== null && ` (${daysToPay} ${daysToPay === 1 ? "dzień" : "dni"})`)),
                    react_1.default.createElement("div", null,
                        react_1.default.createElement("div", { className: "inv-label" }, "Numer konta"),
                        react_1.default.createElement("div", { className: "invoice-mono inv-account" }, parsed.bankAccount || react_1.default.createElement("span", { className: "text-muted" }, "(puste)"))),
                    react_1.default.createElement("div", null,
                        react_1.default.createElement("div", { className: "inv-label" }, "Bank"),
                        react_1.default.createElement("div", null, parsed.bankName || react_1.default.createElement("span", { className: "text-muted" }, "(puste)"))))),
            hasKsefQr && (react_1.default.createElement("div", { className: "inv-section text-center invoice-qr-preview-section" },
                react_1.default.createElement("div", { className: "fw-bold mb-2" }, "Sprawd\u017A, czy Twoja faktura znajduje si\u0119 w KSeF!"),
                react_1.default.createElement("div", { className: "d-inline-flex p-3 bg-white border rounded-3" },
                    react_1.default.createElement(qrcode_react_1.QRCodeSVG, { value: ksefPreviewStatus?.qrVerificationUrl || "", size: 180, level: "M", includeMargin: true })),
                ksefInvoiceNumber && (react_1.default.createElement("div", { className: "mt-2 small text-break" },
                    react_1.default.createElement("strong", null, "Numer KSeF:"),
                    " ",
                    ksefInvoiceNumber)),
                react_1.default.createElement("div", { className: "mt-3 invoice-qr-preview-actions" },
                    react_1.default.createElement(react_bootstrap_1.Button, { as: "a", href: ksefPreviewStatus?.qrVerificationUrl || "", target: "_blank", rel: "noopener noreferrer", size: "sm", variant: "outline-primary" }, "Otw\u00F3rz link")),
                react_1.default.createElement("div", { className: "d-none d-print-block mt-3 small text-break" },
                    react_1.default.createElement("strong", null, "Link weryfikacyjny:"),
                    " ",
                    react_1.default.createElement("span", { className: "invoice-mono" }, ksefPreviewStatus?.qrVerificationUrl))))),
        hasKsefQr && (react_1.default.createElement("div", { className: "invoice-qr-print-section d-none d-print-block mt-4 text-center" },
            react_1.default.createElement("div", { className: "fw-bold mb-2" }, "Sprawd\u017A, czy Twoja faktura znajduje si\u0119 w KSeF!"),
            react_1.default.createElement("div", { className: "d-inline-flex p-3 bg-white border rounded-3" },
                react_1.default.createElement(qrcode_react_1.QRCodeSVG, { value: ksefPreviewStatus?.qrVerificationUrl || "", size: 180, level: "M", includeMargin: true })),
            ksefInvoiceNumber && (react_1.default.createElement("div", { className: "mt-2 small text-break" },
                react_1.default.createElement("strong", null, "Numer KSeF:"),
                " ",
                ksefInvoiceNumber)),
            react_1.default.createElement("div", { className: "mt-3 small text-break" },
                react_1.default.createElement("strong", null, "Link weryfikacyjny:"),
                " ",
                react_1.default.createElement("span", { className: "invoice-mono" }, ksefPreviewStatus?.qrVerificationUrl))))));
}
